import { render, staticRenderFns } from "./CustomerCorporateEmployees.vue?vue&type=template&id=723a2051"
import script from "./CustomerCorporateEmployees.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports